import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

const AvatarStack = ({ images = [], extraCount }) => {
  const visible = images.slice(0, 3);
  const extra = extraCount ?? Math.max(images.length - 3, 0);

  return (
    <div className="flex -space-x-2">
      {visible.map((img, index) => (
        <img
          key={index}
          src={img}
          alt="avatar"
          className="w-8 h-8 rounded-full border-2 border-white object-cover"
        />
      ))}

      {extra > 0 && (
        <div className="w-8 h-8 rounded-full bg-indigo-500 border-2 border-white flex items-center justify-center text-[10px] text-white font-bold">
          +{extra}
        </div>
      )}
    </div>
  );
};

export default function AvatarStackCard({ title, images = [], extraCount, to }) {
  const content = (
    <>
      <div className="flex items-center gap-3">
        <AvatarStack
          images={images}
          extraCount={extraCount}
        />

        <div>
          <p className="text-sm font-bold">{title}</p>

          <span className="text-[#0811D4] text-xs flex items-center gap-1">
            Click to see more
            <ChevronRight size={12} />
          </span>
        </div>
      </div>
    </>
  );

  if (to) {
    return (
      <Link
        to={to}
        className="bg-white p-4 rounded-2xl shadow-sm flex items-center justify-between border border-gray-100 transition hover:-translate-y-0.5 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-[#1234CD]/30"
      >
        {content}
      </Link>
    );
  }

  return (
    <div className="bg-white p-4 rounded-2xl shadow-sm flex items-center justify-between border border-gray-100">
      {content}
    </div>
  );
}
